module.exports = new __parcel__URL__("DrawerIllustration.5c9452ed.svg").toString();